import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import propTypes from './prop-types';

class DeleteDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputFieldError: false
    };
  }

  handleOk = () => {
    const { title, onDelete } = this.props;
    if (this.inputElement.value === title) {
      onDelete();
    } else {
      this.setState({ inputFieldError: true });
    }
  };

  render() {
    const { title, open, onClose: onModalClose } = this.props;

    const onClose = () => {
      this.setState({ inputFieldError: false });
      onModalClose();
    };

    return (
      <div>
        <Dialog
          open={open}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{
              backgroundColor: '#ff4635',
              whiteSpace: 'pre-wrap'
            }}
          >
            Do you want to delete the project &quot;
            {title}
            &quot;?
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              style={{
                marginTop: '8px'
              }}
            >
              Type the project name to confirm
            </DialogContentText>
            <TextField
              label="Project name"
              fullWidth
              margin="normal"
              variant="outlined"
              inputRef={el => (this.inputElement = el)}
              error={this.state.inputFieldError}
              helperText={this.state.inputFieldError ? 'Invalid name' : ''}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={onClose}
              variant="outlined"
              color="primary"
            >
              Cancel
            </Button>
            <Button onClick={this.handleOk} variant="outlined" color="primary" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

DeleteDialog.propTypes = propTypes;

export default DeleteDialog;
